import React from 'react'

import Results from 'modules/resultsV2/Results'

export const ExportAndAccessRequestDetails = (): JSX.Element => {
  return <Results />
}

export default ExportAndAccessRequestDetails
